export const defaultTranslations = {
  start_headline: "Ihre zentrale Verwaltungsstelle aller Reinigungsaufträge",
  werk_standort: "Werk/Standort",
  fachbereich: "Fachbereich",
  abteilung: "Abteilung",
  gebaeude: "Gebäude",
  addAutoOrder: "Automatische Bestellung hinzufügen",
  etage: "Etage",
  anlage: "Anlage",
  pos_nr: "Pos. Nr.",
  pos_name: "Pos.-Name",
  leistungsbeschreibung_kurz: "Leistungsbeschreibung (kurz)",
  leistungsbeschreibung_lang: "Leistungsbeschreibung (lang)",
  preis_1: "Preis Mo-Sa",
  menge: "Menge",
  mengeneinheit: "Mengeneinheit",
  anzahl: "Anzahl",
  preis_2: "Preis So",
  preis_3: "Preis Feiertag",
  preis_4: "Preis Nacht",
  turnus: "Turnus",
  kostenstelle: "Kostenstelle",
  optionen: "Optionen",
  uploads: "Datei-Anhänge",
  uploadNew: "Neue Datei hinzufügen",
  nav_leistungen: "Leistungsverzeichnis",
  nav_überblick: "Übersicht",
  Nav_login: "Login",
  Nav_users: "Benutzerverwaltung",
  Nav_leistungen_hinzufuegen: "LV-Position hinzufügen",
  Nav_einstellungen: "Einstellungen",
  "Nav_startseite-bearbeiten": "Startseite bearbeiten",
  "Nav_leistungen-konfigurueren": "Leistungen konfigurieren",
  Nav_kostenstellen: "Kostenstellen",
  "Nav_projekt-einstellungen": "Projekt Einstellungen",
  Leistung_ueberschrift: "Leistungen beauftragen",
  Leistung_hinzufuegen: "Leistung hinzufügen",
  Leistung_bearbeiten: "Leistung bearbeiten",
  Nav_uebersetzungen: "Übersetzungen",
  Leistung_ueberschrift2:
    "Wählen Sie hier die Anlage aus, für die Sie eine neue Bestellung aufgeben möchten.",
  error_api:
    "Fehler bei der Übermittlung. Bitte überprüfen Sie ihre Eingaben oder wenden Sie sich an den Support.",
  automatische_bestellungen: "Automatische Bestellungen",
  qr_code: "QR-Code",
  qr_code_download: "QR-Code herunterladen",
  Nav_orders: "Beauftragung",
  Nav_create_report: "Abnahmeprotokolle",
  unterschrift_indutec: "Unterschrift Indutec",
  unterschrift_kunde: "Unterschrift Kunde",
  rapport_headline: "Abnahmeprotokoll",
  arbeitsplan_headline: "Arbeitsplan",
  Nav_create_arbeitsplan: "Arbeitspläne ",
  Nav_create_invoice: "Abrechnung erstellen",
  invoice_headline: "Abrechnung",
  "Nav_order-approval": "Digitale Abnahme",
  abrechnung: "Abrechnung",
  nav_überblick_abrechnung: "Übersicht",
  nav_überblick_order: "Übersicht",
};

export const translate = (translationKey) => {
  const translationOverwrites = JSON.parse(
    localStorage.getItem("translations"),
  );

  if (translationOverwrites && translationOverwrites[translationKey]) {
    return translationOverwrites[translationKey];
  } else if (defaultTranslations[translationKey]) {
    return defaultTranslations[translationKey];
  } else {
    return "<TRANSLATION MISSING>";
  }
};
